import {
  Alert,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from '@mui/material';

const PaymentReceiptValidationAlert = ({ data = [] }) => {
  if (!data || data.length === 0) return null;

  return (
    <Alert severity="error">
      <Box>
        {data.map((paidItem, i) => (
          <Box key={i} sx={{ mb: 4 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {`> ${paidItem?.course_available?.course_name || 'Course Not Available'} - (Enrolled by: ${
                paidItem?.createdBy || 'Unknown'
              })`}
            </Typography>

            <TableContainer component={Paper} sx={{ maxWidth: 1000, margin: 'auto', mt: 2 }}>
              <Typography variant="h6" sx={{ p: 2 }}>
                Payment Logs
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Invoice ID</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Payment Method</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Payable Amount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Transaction Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Created By</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Created Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Paid Status</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Receipt Downloaded</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paidItem?.CartPaymentLogs?.map((item, index) => (
                    <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
                      <TableCell>{item.invoiceId}</TableCell>
                      <TableCell>{item.paymentMethod}</TableCell>
                      <TableCell>₹{item.payableAmt}</TableCell>
                      <TableCell>{item.transactionDate}</TableCell>
                      <TableCell>{item.createdBy?.name || 'N/A'}</TableCell>
                      <TableCell>{item.createdDate}</TableCell>
                      <TableCell>
                        <Chip
                          label={item.paidStatus ? 'Paid' : 'Unpaid'}
                          color={item.paidStatus ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={item.PaymentInvoice?.is_downloaded ? 'Downloaded' : 'Not Downloaded'}
                          color={item.PaymentInvoice?.is_downloaded ? 'success' : 'warning'}
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ))}

        <Typography sx={{ mt: 2 }}>
          Please check the payment logs of the mentioned enrolled courses. The payment receipts for these courses have
          not been downloaded or shared with parents.
        </Typography>
      </Box>
    </Alert>
  );
};

export default PaymentReceiptValidationAlert;
